import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Card, CardBody, Modal, ModalHeader, ModalBody, Form, ModalFooter, Button, Spinner, FormGroup, Label, Input } from 'reactstrap';
import './WinterGrazing.css';
import NonMapView from '../ItemsView/NonMapView';
import toast, { Toaster } from 'react-hot-toast';
import Validate from '../Validate/Validate';
import axios from 'axios';
import ItemCommonTop from '../ItemPopup/ItemCommonTop';
import ItemCommonBottomWinterGrazing from '../ItemPopup/ItemCommonBottomWinterGrazing';
import ItemFooter from '../ItemPopup/ItemFooter';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import { FaChevronUp, FaChevronDown, FaChevronRight, FaChevronLeft, FaTrash, FaPlus } from 'react-icons/fa';
import uuid from 'react-uuid';
import MapView from '../Map/MapView';
import ToggleSwitch from '../ThreeStateToggle/ToggleSwitch';
import { useNavigate } from "react-router-dom";
import Documents from '../Uploads/Documents';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import Select, { components, ValueContainerProps } from 'react-select';
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import WinterGrazingItemSpecView from './WinterGrazingItemSpecView'

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const WinterGrazing = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const isAddEditItem = localStorage.getItem("isAddEditItem");
    const [farmName, setFarmName] = useState(JSON.parse(localStorage.getItem("defaultFarmName"))); const [farmUniqueId, setFarmUniqueId] = useState(JSON.parse(localStorage.getItem("defaultFarmUniqueId")));
    const roleName = localStorage.getItem("roleName"); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(true);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables"); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); const [toggleSwitch, setToggleSwitch] = useState('map & details');
    const [loading, setLoading] = useState(true);
    const [itemList, setItemList] = useState([]);
    const [imageUploadList, setImageUploadList] = useState([]);
    const [winterGrazing, setWinterGrazing] = useState({ uniqueItemTypes: [], itemFieldTypes: [], isWizardCompleted: false, itemTypes: [], outlineList: [], isMapOnly:true, itemList: [], SectionName: 'Winter Grazing', Section: 'Winter Grazing', isWizardCompleted: false, sectionObj: {}, sectionComment: '' });
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isWinterGrazingPage: true, isCenterReq: false, isFarmCenterEditable: false, isFarmOutlineEditable: false, zoomLevel: 15,
        polyType: '', itemsEditable: false, highlighteditemId: 0, isClear: false, showLabel:true
    });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0 })
    const [isOpen, setIsOpen] = useState(false); const [isIconUp, setIsIconUp] = useState(false);
    const [isOpen1, setIsOpen1] = useState(false); const [isIconUp1, setIsIconUp1] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const toggle1 = () => {
        setIsOpen1(!isOpen1)
        setIsIconUp1(!isIconUp1)
    };
    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setWinterGrazing({ ...winterGrazing, sectionComment: value })
    }
    const navigate = useNavigate();
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const OnPageload = async (e) => {
        try {
            const response = await axios.get(
                '/api/wintergrazing/GetWinterGrazing/', {
                params: {
                    farmId: farmId
                }
            }
            );
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            setWinterGrazing({
                ...winterGrazing, itemFieldTypes: response.data.itemFeildList, isWizardCompleted: response.data.isFWFPCompleted, itemTypes: response.data.itemTypes, outlineList: response.data.outlineList, uniqueItemTypes: response.data.uniqueItemTypes, itemList: response.data.itemList, isWizardCompleted: response.data.isFWFPCompleted, sectionObj: response.data.section, sectionComment: response.data.sectionComment
            });
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, polyType: '' });
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            const content = ContentState.createFromBlockArray(convertFromHTML(response.data.sectionComment == null ? '' : response.data.sectionComment))
            setEditorState(EditorState.createWithContent(content));
            setBlockOnly({ ...blockOnly, zoomLevelList: response.data.zoomLeveList, showCenterPin: false, showCenterPinPopup: false, name: '', islargeEnterprise: response.data.islargeEnterprise })
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }

    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    const handleMapItemEdited = (itemId, type, strValue) => {
        let name = '';
        let value = '';
        if (type == "polygonBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }
        else if (type == "polylineBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }

        const itemList = winterGrazing.itemList.map(item =>
            item.itemId === itemId
                ? { ...item, [name]: value, isEdited: true }
                : item
        )
        setWinterGrazing({ ...winterGrazing, itemList: itemList });
    }
    const [blockOnly, setBlockOnly] = useState({
        defaultZoomLevel: 15,
        isViewBlockOnly: false,
        name: '',
        itemId: 0,
        coordinates: '',
        showCenterPinPopup: false,
        actionType: '',
        zoomLevelList: [],
        islargeEnterprise: false, showCenterPin:false
    })
    const addMapItem = (mapItem, maptype) => {
        let path, area = 0.0, perimeter = 0.0, coordinates = '';
        if (typeid != 0) {
            var selectedItemType = winterGrazing.itemTypes.filter(item => item.id == typeid)[0];
            const ItemTypeName = selectedItemType.name;
            const isBiodiversityReq = selectedItemType.isBiodiversityReq == true ? true : false;
            let lmuId = largeEnterpriseDetails.selectedLMUId;
            const defaultColour = selectedItemType.defaultColour != null && selectedItemType.defaultColour != '' ? selectedItemType.defaultColour : "#21b546";

            /***********LMU Identification*************/
            if (maptype == 'marker') {
                largeEnterpriseDetails.LMUList.map((obj) => {
                    const outlineCoordinates = obj.mapCoordinates.split(':');
                    const outlinepositions = [];
                    outlineCoordinates.filter(coor => coor != "").map((Coordinate) => {
                        const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                        outlinepositions.push(pos);
                    })
                    const outlinePolygon = new window.google.maps.Polygon({
                        paths: outlinepositions
                    });
                    const pos = { lat: mapItem.getPosition().lat(), lng: mapItem.getPosition().lng() }

                    const inside = window.google.maps.geometry.poly.containsLocation(
                        pos,
                        outlinePolygon
                    ) ? true : false;
                    if (inside) {
                        lmuId = obj.id;
                    }
                });
            }
            /***********LMU Identification*************/

            if (maptype == 'marker') {

                coordinates = mapItem.getPosition().lat().toFixed(6) + ", " + mapItem.getPosition().lng().toFixed(6);
            }
            else if (maptype == 'polygon') {
                path = mapItem.getPath();
                area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                var PolygonCoords = "";
                path.getArray().map((pointCo) => {

                    PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
                })
                coordinates = PolygonCoords;
            }
            else if (maptype == 'polyline') {
                path = mapItem.getPath();
                area = 0;
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                var PolygonCoords = "";
                path.getArray().map((pointCo) => {

                    PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
                })
                coordinates = PolygonCoords;
                if (path.getArray().length <= 1) {
                    toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    resetValues();
                    return false;
                }
            }
            setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: 0, itemId: 0, markertype: maptype, canArchive: true, isMapOnly: true });
            setItemPopupMaptype({ ...itemPopupMaptype, markertype: maptype, area: area, perimeter: perimeter, coordinates: coordinates });
            setItemPopupHeader({ ...itemPopupHeader,id:0, itemTypeName: ItemTypeName, itemTypeId: typeid, LMUId: lmuId, LMUIds: lmuId.toString(), Name: '', isDragged: false, Description: '', color: defaultColour, isEdited: false, itemTypeDescription: selectedItemType.itemDescription, watertakeType: 0 });
        }
        else {
            if (maptype == 'marker') {
                const item = winterGrazing.itemList.filter(item => item.itemId == blockOnly.itemId)[0];
                coordinates = mapItem.getPosition().lat().toFixed(6) + ", " + mapItem.getPosition().lng().toFixed(6);
                setBlockOnly({ ...blockOnly, name: item.name + ' - Centre Pin', showCenterPin: false, coordinates: coordinates, showCenterPinPopup: true, actionType: 'Add New' })
            }
        }
    }
    
    const handleCenterPinClick = (event, polyType, itemId) => {
        setBlockOnly({ ...blockOnly, itemId: itemId })
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
    }

    const editMapItem = (mapItem, itemId, isDragged) => {
        const itemDetails = winterGrazing.itemList.filter(items => items.itemId == itemId)[0];
        const ItemTypeName = winterGrazing.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
        if (ItemTypeName != 'Gateway' && ItemTypeName != 'Permanent water trough' &&
            ItemTypeName != 'Shelter' && ItemTypeName != 'Baleage placement' &&
            ItemTypeName != 'Portable trough') {
            const ItemDescription = winterGrazing.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
            let coordinates = itemDetails.mapCoordinates;
            if (isDragged) {
                coordinates = mapItem.latLng.lat().toFixed(6) + ", " + mapItem.latLng.lng().toFixed(6);
            }
            let area = 0.0, perimeter = 0.0;
            if (itemDetails.isEdited == true) {
                if (itemDetails.mapMarkerType == "polygon") {
                    const Coordinates = coordinates.split(':');
                    const positions = [];
                    Coordinates.filter(coor => coor != "").map((Coordinate) => {
                        const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                        positions.push(pos);
                    })
                    const tempPolygon = new window.google.maps.Polygon({
                        paths: positions
                    });

                    let path = tempPolygon.getPath();
                    area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
                    perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                }
                else if (itemDetails.mapMarkerType == "polyline") {
                    const Coordinates = coordinates.split(':');
                    const positions = [];
                    Coordinates.filter(coor => coor != "").map((Coordinate) => {
                        const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                        positions.push(pos);
                    })

                    const tempPolyline = new window.google.maps.Polyline({
                        paths: positions
                    });

                    let path = tempPolyline.paths;
                    area = itemDetails.area;
                    perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                    if (path.length <= 1) {
                        toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                        resetValues();
                        return false;
                    }
                }
            }
            else {
                area = itemDetails.area;
                perimeter = itemDetails.length;
            }
            if (itemDetails != null) {
                setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType, canArchive: itemDetails.canArchive });
                setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates });
                setItemPopupHeader({
                    ...itemPopupHeader, id: itemId, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds: itemDetails.lmuIds == null ? '' : itemDetails.lmuIds,
                    Name: itemDetails.name, isDragged: isDragged, Description: itemDetails.description, color: itemDetails.colour, isEdited: itemDetails.isEdited, itemTypeDescription: ItemDescription,
                    watertakeType: itemDetails.watertakeType
                });
                const itemFieldTypesList = winterGrazing.itemFieldTypes.filter(fieldType => fieldType.itemTypeId == itemDetails.itemTypeId);
                setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: itemDetails.itemTypeId, itemFieldTypes: itemFieldTypesList });

                setItemPopupItemSepcQ({
                    MobNameAndsize: itemDetails.mobNameAndsize,
                    DietFollowingTransition: itemDetails.dietFollowingTransition,
                    StockTransitionPlan: itemDetails.stockTransitionPlan,
                    MudReduction: itemDetails.mudReduction,
                    AnimalHealthAndWelfareMonitoring: itemDetails.animalHealthAndWelfareMonitoring,
                    RiskReductionOfCalvingLambingOnCrop: itemDetails.riskReductionOfCalvingLambingOnCrop,
                    EnsuringStockAreWellFed: itemDetails.ensuringStockAreWellFed,
                    EnsuringEveryoneUnderstandsThePlan: itemDetails.ensuringEveryoneUnderstandsThePlan,
                    WetWeatherPlanImplementation: itemDetails.wetWeatherPlanImplementation,
                    WetWeatherPoorSoilConditions: itemDetails.wetWeatherPoorSoilConditions,
                    ImplementingAnAdversePlan: itemDetails.implementingAnAdversePlan,
                    AdverseEventPlanDetail: itemDetails.adverseEventPlanDetail,
                    GoodManagementPracticeEvidence: itemDetails.goodManagementPracticeEvidence,
                    ReviewingTheWinteringPlan: itemDetails.reviewingTheWinteringPlan,
                });

            }
        }
        else {
            setItemDeletePopup1({ ...itemDeletePopup1, showItemDeletePopup: true, itemId: itemId });
        }
    }

    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '95vw' : '50vw'}
                height={toggleSwitch == 'map' ? '95vw' : '50vw'}
                itemModel={winterGrazing}
                mapDetails={mapDetails} blockViewOnly={blockOnly}
                largeEnterpriseDetails={largeEnterpriseDetails}
                addMapItem={addMapItem}
                editMapItem={editMapItem}
                handleMapItemEdited={handleMapItemEdited}
            >
            </MapView>
        )
    }, [blockOnly,winterGrazing, mapDetails, largeEnterpriseDetails, toggleSwitch])

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }
    const handlePageChange = async (section, method) => {
        await SaveSectionComment();
        if (method == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }
    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))//infrastructure.sectionComment
            };
            const response = await axios.post(
                '/api/WinterGrazing/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }
    const SaveSectionComment = async () => {
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await axios.post(
                '/api/WinterGrazing/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });

        } catch (err) {
            console.log(err);
        }
    }

    const [savingSectionComment, setSavingSectionComment] = useState('');
    const [showCenterPin, setShowCenterPin] = useState(false);
    const toggleShowCenterPin = () => {
        setShowCenterPin(!showCenterPin);
        setBlockOnly({ ...blockOnly, showCenterPin: !showCenterPin });
    };
    const [typeid, setTypeId] = useState(0);
    const [toggleItemTypeListState, setToggleItemTypeListState] = useState({ isOpen: false, isIconUp: false });
    const [toggleItemTypeState, setToggleItemTypeState] = useState({ itemTypeId: 0, isOpen: false, isIconUp: false });
    const [toggleItemState, setToggleItemState] = useState({ itemId: 0, isOpen: false, isIconUp: false });
    const [itemPopupItemFeild, setItemPopupItemFeild] = useState({
        itemTypeId: 0,
        itemFieldTypes: []
    });
    const handleClearSelection = () => {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: 0, itemFieldTypes: [] });
        window.location.reload(true);
    }
    const handleItemClick = (event, typeid, polyType) => {
        setTypeId(typeid);
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
        const itemFieldTypesList = winterGrazing.itemFieldTypes.filter(fieldType => fieldType.itemTypeId == typeid);
        setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: typeid, itemFieldTypes: itemFieldTypesList });
    }
    const handleItemEditPopup = (itemId) => {
        editMapItem([], itemId, false)
    }
    const [itemPopup, setItemPopup] = useState({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true });
    const [itemPopupHeader, setItemPopupHeader] = useState({id:0,
        page: 'Winter Grazing', lmu: '', LMUId: 0, itemTypeName: '', LMUIds: '',
        itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", isEdited: false, itemTypeDescription: '', watertakeType: 0, watertakeTypeList: []
    });
    const [formErrors, setFormErrors] = useState({});
    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemDeletePopup: false, itemId: 0 });
    const [itemDeletePopup1, setItemDeletePopup1] = useState({ showItemDeletePopup: false, itemId: 0 });
    const resetValues = () => {
        setItemPopup({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true });
        setItemPopupHeader({ id: 0, page: 'Winter Grazing', lmu: '', LMUIds: '', itemTypeName: '', itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", isEdited: false, itemTypeDescription: '', watertakeType: 0 });
        setItemPopupMaptype({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
        setItemDeletePopup({ showItemdeletePopup: false, itemId: 0 });
        setFormErrors({});
        setMapDetails({ ...mapDetails, isClear: true, polyType: '' });
    }
    const [itemPopupMaptype, setItemPopupMaptype] = useState({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
    const [itemPopupItemSepcQ, setItemPopupItemSepcQ] = useState({
        MobNameAndsize: '',
        DietFollowingTransition: '',
        StockTransitionPlan: '',
        MudReduction: '',
        AnimalHealthAndWelfareMonitoring: '',
        RiskReductionOfCalvingLambingOnCrop: '',
        EnsuringStockAreWellFed: '',
        EnsuringEveryoneUnderstandsThePlan: '',
        WetWeatherPlanImplementation: '',
        WetWeatherPoorSoilConditions: '',
        ImplementingAnAdversePlan: '',
        AdverseEventPlanDetail: '',
        GoodManagementPracticeEvidence: '',
        ReviewingTheWinteringPlan:''
    });
    
    const handleItemTypeListTogole = (isOpen, isIconUp) => {
        setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemTypeTogole = (itemTypeId, isOpen, isIconUp,) => {
        setToggleItemTypeState({ ...toggleItemTypeState, itemTypeId: itemTypeId, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemTogole = (itemId, isOpen, isIconUp) => {
        setToggleItemState({ ...toggleItemState, itemId: itemId, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleBlockOnlySelect = (event, itemId, zoomlevel) => {
        const { name, value, checked, type } = event.target;
        let selectedItemId = 0;
        if (name == 'isViewBlockOnly' && checked == true) {
            selectedItemId = itemId;
        }
        const defaultZoomlevel = zoomlevel == null ? mapDetails.zoomLevel : zoomlevel;
        setBlockOnly({ ...blockOnly, itemId: selectedItemId, showCenterPin: false, defaultZoomLevel: defaultZoomlevel, [name]: type == 'checkbox' ? checked : value });
    }
    const handleBlockZoomlevelSave = (event, itemId, value) => {
        if (blockOnly.itemId == itemId) {
            setBlockOnly({ ...blockOnly, defaultZoomLevel: value })
            handleZoomLevelSave();
        }
    }

    const handleZoomLevelSave = async () => {

        const form = {
            Id: blockOnly.id,
            ItemId: blockOnly.itemId,
            DefaultZoomlevel: blockOnly.defaultZoomLevel,
            updatedBy: userId
        }
        try {
            const response = await axios.post(
                '/api/WinterGrazing/saveDefaultZoomLevel/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                });
            if (response.data != null) {
                await refreshItemDetails();
                toast.success("Zoom level saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            }
        } catch (error) {
            console.log(error);
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    const handleBlockZoomlevel = (event, itemId) => {
        const { name, value, checked, type } = event.target;

        if (blockOnly.isViewBlockOnly = true && itemId == blockOnly.itemId) {
            setBlockOnly({ ...blockOnly, itemId: itemId, [name]: type == 'checkbox' ? checked : parseInt(value) });
        }
    }
    const handleItemDeletePopup = (itemId) => {
        setItemDeletePopup({ showItemDeletePopup: true, itemId: itemId });
    }
    const nonMapView = useMemo(() => {
        return (
            <NonMapView handleBlockZoomlevelSave={handleBlockZoomlevelSave} blockOnly={blockOnly}
                handleBlockOnlySelect={handleBlockOnlySelect} handleBlockZoomlevel={handleBlockZoomlevel}
                show_HistoricalActions={show_HistoricalActions} handleCenterPinClick={handleCenterPinClick}
                itemModel={winterGrazing} handleSectionCommentChange={handleSectionCommentChange}
                toggleItemTypeListState={toggleItemTypeListState}
                toggleItemTypeState={toggleItemTypeState} mapDetails={mapDetails}
                toggleItemState={toggleItemState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemEditPopup={handleItemEditPopup} handleItemDeletePopup={handleItemDeletePopup}
                sectionObj={winterGrazing.sectionObj}
                largeEnterpriseDetails={largeEnterpriseDetails}
                handleItemTypeListTogole={handleItemTypeListTogole}
                handleItemTypeTogole={handleItemTypeTogole}
                handleItemTogole={handleItemTogole} toggleShowCenterPin={toggleShowCenterPin}
                handleItemHighlight={handleItemHighlight} outlineCenter={winterGrazing.outlineCenter}
            ></NonMapView>
        )
    }, [blockOnly, winterGrazing, toggleShowCenterPin,largeEnterpriseDetails, winterGrazing.SectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState, winterGrazing.outlineCenter])

    const refreshItemDetails = async () => {
        const response = await axios.get(
            '/api/WinterGrazing/GetWinterGrazing/', {
            params: {
                farmId: farmId
            }
        }
        );
        setWinterGrazing({
            ...winterGrazing, itemList: response.data.itemList, outlineCenter: response.data.outlineCenter
        });
        setTypeId(0);
    }

    const handleItemSubmit = async (event) => {
        setFormErrors({});
        setSaving(true);
        const errors = {};

        if (Object.keys(errors).length == 0) {
            let form = {
                Id: itemPopup.id,
                MapMarkerType: itemPopup.markertype,
                FarmId: itemPopup.farmId,
                ItemId: itemPopup.itemId,
                Name: itemPopupHeader.Name,
                IsDragged: itemPopupHeader.isDragged,
                Description: itemPopupHeader.Description,
                Colour: itemPopupHeader.color,
                LMUId: itemPopupHeader.LMUId,
                ItemTypeId: itemPopupHeader.itemTypeId,
                Area: itemPopupMaptype.area,
                Length: itemPopupMaptype.perimeter,
                MapCoordinates: itemPopupMaptype.coordinates,
                userId: userId,
                IsEdited: itemPopupHeader.isEdited, ImageUploadList: [],
                MobNameAndsize: itemPopupItemSepcQ.MobNameAndsize,
                DietFollowingTransition: itemPopupItemSepcQ.DietFollowingTransition,
                StockTransitionPlan: itemPopupItemSepcQ.StockTransitionPlan,
                MudReduction: itemPopupItemSepcQ.MudReduction,
                AnimalHealthAndWelfareMonitoring: itemPopupItemSepcQ.AnimalHealthAndWelfareMonitoring,
                RiskReductionOfCalvingLambingOnCrop: itemPopupItemSepcQ.RiskReductionOfCalvingLambingOnCrop,
                EnsuringStockAreWellFed: itemPopupItemSepcQ.EnsuringStockAreWellFed,
                EnsuringEveryoneUnderstandsThePlan: itemPopupItemSepcQ.EnsuringEveryoneUnderstandsThePlan,
                WetWeatherPlanImplementation: itemPopupItemSepcQ.WetWeatherPlanImplementation,
                WetWeatherPoorSoilConditions: itemPopupItemSepcQ.WetWeatherPoorSoilConditions,
                ImplementingAnAdversePlan: itemPopupItemSepcQ.ImplementingAnAdversePlan,
                AdverseEventPlanDetail: itemPopupItemSepcQ.AdverseEventPlanDetail,
                GoodManagementPracticeEvidence: itemPopupItemSepcQ.GoodManagementPracticeEvidence,
                ReviewingTheWinteringPlan: itemPopupItemSepcQ.ReviewingTheWinteringPlan,
            }
            for (var i = 0; i < imageUploadList.length; i++) {
                var obj = {};
                obj.Id = imageUploadList[i].id;
                obj.ImageDetail = imageUploadList[i].imageDetail;
                obj.ImageName = imageUploadList[i].imageName;
                obj.ImagePhysicalName = imageUploadList[i].imagePhysicalName;
                obj.ImagePath = imageUploadList[i].imagePath;
                form.ImageUploadList.push(obj);
            }
            if (!Validate(form)) {
                try {
                    const response = await axios.post(
                        '/api/wintergrazing/UpdateWinterGrazing/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        });
                    if (response.data != null) {
                        await refreshItemDetails();
                        setSaving(false);
                        toast.success("Item details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                        handleItemPopupClose();
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }
            else {
                setSaving(false);
            }
        }
        else {
            setSaving(false);
        }
    }

    const [saving, setSaving] = useState('');
    const handleItemPopupClose = () => {
        resetValues();
    }
    const handleItemPopupHeaderChange = (event) => {
        const { name, value, checked, type } = event.target;
        if (name == 'Name') {
            if (event.target.value.length > 60) {
                return false;
            }
        }
        setFormErrors({});
        setItemPopupHeader({ ...itemPopupHeader, [name]: type == 'checkbox' ? checked : value });
    }
    

    const handleItemDeletePopupClose = () => {
        setItemDeletePopup({ showItemDeletePopup: false, itemId: 0 });
    }
    const handleItemDeletePopupClose1 = () => {
        setItemDeletePopup1({ ...itemDeletePopup1,showItemDeletePopup: false, itemId: 0 });
    }
    const handleItemSepcValueChange = (event) => {
        const { name, value, checked, type } = event.target;
        setItemPopupItemSepcQ({ ...itemPopupItemSepcQ, [name]: type == 'checkbox' ? checked : value });
    }
    const handleClearSelection1 = () => {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
    }
    const handleCenterPinPopupClose = () => {
        handleClearSelection1();
        setBlockOnly({ ...blockOnly, showCenterPinPopup: false, showCenterPin: false, name: '', itemid: 0, coordinates: '', actionType: '' })
        setMapDetails({ ...mapDetails, isClear: true });

    }
    const handleCenterPinDelete = async () => {
        const itemid = blockOnly.itemId;

        try {
            const response = await axios.get(
                '/api/lmu/deleteCenterPin/', {
                params: {
                    itemId: itemid
                }
            });

            if (response.data != null) {
                toast.success("Center Pin deleted!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                handleCenterPinPopupClose();
                await refreshItemDetails();
            }
        } catch (error) {
            console.log(error);
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }
    const handleCenterPinSave = async () => {

        const form = {
            Id: blockOnly.id,
            ItemId: blockOnly.itemId,
            CenterCoordinates: blockOnly.coordinates,
            DefaultZoomlevel: blockOnly.defaultZoomLevel,
            updatedBy: userId
        }
        try {
            const response = await axios.post(
                '/api/WinterGrazing/saveCenterPin/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                });
            if (response.data != null) {
                toast.success("Center Pin saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                handleCenterPinPopupClose();
                await refreshItemDetails();
            }
        } catch (error) {
            console.log(error);
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }
    const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const deleteItem = async (event) => {
        setItemDeleteSaving(true);
        const itemid = itemDeletePopup.itemId;
        try {
            const response = await axios.get(
                '/api/WinterGrazing/DeleteItem/', {
                params: {
                    itemId: itemid, userId: userId
                }
            });
            if (response.data != null) {
                await refreshItemDetails();
                setItemDeleteSaving(false);
                handleItemDeletePopupClose();
                handleItemDeletePopupClose1();
                handleItemPopupClose();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }
    const deleteItem1 = async (event) => {
        setItemDeleteSaving(true);
        const itemid = itemDeletePopup1.itemId;
        try {
            const response = await axios.get(
                '/api/WinterGrazing/DeleteItem/', {
                params: {
                    itemId: itemid, userId: userId
                }
            });
            if (response.data != null) {
                await refreshItemDetails();
                setItemDeleteSaving(false);
                handleItemDeletePopupClose();
                handleItemDeletePopupClose1();
                handleItemPopupClose();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }
    const handleEditItemClick = (e) => {
        if (e.target.checked) {
            toast.error("ALERT: when editing a shape remember to click inside the shape when finished, or when editing a line double click on the line, to save any changes.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        setMapDetails({ ...mapDetails, isFarmCenterEditable: !mapDetails.itemsEditable, isFarmOutlineEditable: !mapDetails.itemsEditable, itemsEditable: !mapDetails.itemsEditable })
    }

    const exportWinterGrazingPlan = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleWinterGrazingPlan();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }


    const handleWinterGrazingPlan = async (e) => {
        const response = await axios.get(
            '/api/WinterGrazing/GenerateWinterGrazingPlan/', {
            params: { userId: userId, farmId: farmId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "Winter Grazing Plan - " + farmName.toString() + " - " + farmUniqueId.toString() + ".pdf";
            document.body.appendChild(link)
            link.click();
        }

    }

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{winterGrazing.SectionName}</h3></Col>
                {!loading &&
                    <Col>
                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(winterGrazing.Section, 'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        {roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(winterGrazing.Section, 'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(winterGrazing.Section, 'handleWizardChangedBack')}>Back <FaChevronLeft /> </Button>
                    </Col>
                }
            </Row>
            {
                loading ? <SpinnerContainer /> :
                    <div>
                        <Row style={{ marginTop: '10px' }}>
                            <Col id='mapView'>
                                <Row className="map-layer" style={{ marginTop: '10px' }}>
                                    <Col>
                                        <Row>
                                            <Col sm="3"> {toggleSwitch == 'map & details' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_expand.png" className="card_icon" ></img>
                                                </Button>
                                            }
                                                {toggleSwitch == 'map' &&
                                                    <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                        <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                    </Button>
                                                }
                                            </Col>
                                            <Col sm="1"></Col>
                                            <Col sm="8">
                                                <div className="map-item-edit-div">
                                                    <Label className="map-checkbox-label">Edit Item</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.itemsEditable} onChange={(e) => handleEditItemClick(e)} name="isItemEdit" id="isItemEdit" />&nbsp;&nbsp;
                                                    <Label className="map-checkbox-label">Show Label</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.showLabel} onChange={(e) => setMapDetails({ ...mapDetails, showLabel: !mapDetails.showLabel })} name="showLabel" id="showLabel" />&nbsp;&nbsp;
                                                </div>
                                            </Col>
                                        </Row>
                                        {mapView}
                                    </Col>
                                </Row>
                            </Col>
                            <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', }}>
                                <Row style={{ marginTop: '10px' }}>
                                    <Col sm="3">
                                        {toggleSwitch == 'map & details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                                <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                        {toggleSwitch == 'details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                                <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Card className="cardNonLeftRadius">
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                                            <Row>
                                                                <Col>
                                                                    <Row>
                                                                        <Col sm="6">
                                                                            <h4>Intensive Winter Grazing</h4>
                                                                        </Col>
                                                                        <Col sm="6">
                                                                            <Row>
                                                                                <Col sm="6"></Col>
                                                                                <Col sm="6"><Button style={{ fontSize: "13px",float:"right" }} color="success" onClick={(e) => exportWinterGrazingPlan(e)} size="sm">Print Plan <img src="/images/PDF_icon.png" className="card_icon" ></img></Button></Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <Label className="info-text">Draw a winter grazing area, waterways or critical source areas to avoid, map the existing infrastructure, map the grazing plan, then complete the subsequent checklist</Label>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <hr />
                                                            {show_SectionComment &&
                                                                <>
                                                                    <Row style={{ marginTop: "0.5vh" }}>
                                                                        <Col sm="12">
                                                                            <FormGroup>
                                                                                <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "16px" }}><b>Wintering description</b> {/*<span className="text-lowercase">(add any information around the features, actions, or risks, that have been considered on this page)</span>*/}</Label>
                                                                                <Editor handlePastedText={() => false}
                                                                                    defaultEditorState={editorState}
                                                                                    onEditorStateChange={setEditorState}
                                                                                    wrapperClassName="wrapper-class"
                                                                                    editorClassName="editor-class"
                                                                                    toolbarClassName="toolbar-class"
                                                                                    toolbar={
                                                                                        {
                                                                                            options: ['inline'], inline: {
                                                                                                inDropdown: false,
                                                                                                options: ['bold', 'italic', 'underline'],
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                />
                                                                            </FormGroup>

                                                                        </Col>
                                                                        <Col sm="12">
                                                                            {savingSectionComment ?
                                                                                <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                                                                    <Row>
                                                                                        <Col sm="8">
                                                                                            <span>
                                                                                                {' '}Saving
                                                                                            </span>
                                                                                        </Col>
                                                                                        <Col sm="4">
                                                                                            <Spinner size="sm">
                                                                                                Saving...
                                                                                            </Spinner>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Button>
                                                                                :
                                                                                <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                                                                    Save
                                                                                </Button>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                    <br />
                                                                </>
                                                            }
                                                            <Row>
                                                                <Col>
                                                                    {nonMapView}
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {
                                            winterGrazing.sectionObj.isDocumentUploadReq && <Documents refid={winterGrazing.sectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Modal size="lg" isOpen={itemPopup.showItemPopup} backdrop={false} className="itemPopup">
                            <Form>
                                <ModalHeader toggle={handleItemPopupClose} >Add/Edit Item</ModalHeader>
                                {
                                    itemPopupHeader.itemTypeName != 'Gateway' && itemPopupHeader.itemTypeName != 'Permanent water trough' &&
                                    itemPopupHeader.itemTypeName != 'Shelter' && itemPopupHeader.itemTypeName != 'Baleage placement' &&
                                    itemPopupHeader.itemTypeName != 'Portable trough' &&
                                    <>
                                        <ModalBody>
                                            <ItemCommonTop setFormErrors={setFormErrors} Section={winterGrazing.Section}
                                                itemPopupHeader={itemPopupHeader} itemPopupMaptype={itemPopupMaptype}
                                                largeEnterpriseDetails={largeEnterpriseDetails} formErrors={formErrors}
                                                handleItemPopupHeaderChange={handleItemPopupHeaderChange}
                                            ></ItemCommonTop>
                                            {itemPopupHeader.itemTypeName == 'Paddock' &&
                                                <WinterGrazingItemSpecView
                                                    handleItemPopupHeaderChange={handleItemPopupHeaderChange}
                                                    itemPopupHeader={itemPopupHeader} itemPopupItemFeild={itemPopupItemFeild}
                                                    itemPopupItemSepcQ={itemPopupItemSepcQ}
                                                    handleItemSepcValueChange={handleItemSepcValueChange}></WinterGrazingItemSpecView>
                                            }
                                            {itemPopupHeader.id != 0 &&
                                                <ItemCommonBottomWinterGrazing itemType={itemPopupHeader.itemTypeName} Section={winterGrazing.Section} setImageUploadList={setImageUploadList}
                                                    imageUploadList={imageUploadList} itemPopup={itemPopup}></ItemCommonBottomWinterGrazing>
                                            }
                                            
                                        </ModalBody>
                                    </>
                                }
                                {
                                    (itemPopupHeader.itemTypeName == 'Gateway' || itemPopupHeader.itemTypeName == 'Permanent water trough' ||
                                    itemPopupHeader.itemTypeName == 'Shelter' || itemPopupHeader.itemTypeName == 'Baleage placement' ||
                                    itemPopupHeader.itemTypeName == 'Portable trough') &&
                                    <>
                                            <ModalBody>
                                                <Row>
                                                    <Col>
                                                    <h6>Are you sure you want to add this item ?</h6>
                                                    </Col>
                                                </Row>
                                            </ModalBody>
                                    </>
                                }
                                <ItemFooter saving={saving} itemPopup={itemPopup}
                                    handleItemDeletePopup={handleItemDeletePopup}
                                    handleItemSubmit={handleItemSubmit} Section={winterGrazing.Section}
                                    handleItemPopupClose={handleItemPopupClose}>
                                </ItemFooter>
                            </Form>
                        </Modal>
                        <Modal size="lg" isOpen={blockOnly.showCenterPinPopup} backdrop={false} className="centerPinPopup">
                            <Form>
                                <ModalHeader toggle={handleCenterPinPopupClose} >Add/Edit Paddock Centre</ModalHeader>
                                <ModalBody>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label>Name</Label>
                                                <Input type="text" name="txtShapeName" id="txtShapeName" value={blockOnly.name} readOnly disabled />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label>GPS Location : </Label><Label id="lblOutlineloaction">{blockOnly.coordinates}</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </ModalBody>
                                <ModalFooter>
                                    {blockOnly.actionType != "Add New" ? <Button color="danger" onClick={handleCenterPinDelete} size="sm">Delete</Button> : ''}
                                    <Button color="success" onClick={handleCenterPinSave} size="sm">Save</Button>
                                    <Button color="primary" onClick={handleCenterPinPopupClose} size="sm">Cancel</Button>

                                </ModalFooter>
                            </Form>
                        </Modal>
                        <Modal isOpen={itemDeletePopup.showItemDeletePopup}>
                            <ModalHeader toggle={handleItemDeletePopupClose} >Archive the paddock</ModalHeader>
                            <ModalBody>
                                Do you want to archive the paddock ?
                            </ModalBody>
                            <ModalFooter>
                                {itemDeletesaving ?
                                    <>
                                        <Button onClick={deleteItem} color="primary" disabled>
                                            <Row>
                                                <Col sm="6">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="6">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row></Button>{' '}
                                    </>
                                    :
                                    <>
                                        <Button onClick={deleteItem} color="primary">
                                            Yes
                                        </Button>{' '}
                                    </>
                                }
                                <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>
                            </ModalFooter>
                        </Modal>
                        <Modal isOpen={itemDeletePopup1.showItemDeletePopup}>
                            <ModalHeader toggle={handleItemDeletePopupClose1} >Archive Item</ModalHeader>
                            <ModalBody>
                                Are you sure you wish to archive ?
                            </ModalBody>
                            <ModalFooter>
                                {itemDeletesaving ?
                                    <>
                                        <Button onClick={deleteItem1} color="primary" disabled>
                                            <Row>
                                                <Col sm="6">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="6">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row></Button>{' '}
                                    </>
                                    :
                                    <>
                                        <Button onClick={deleteItem1} color="primary">
                                            Archive
                                        </Button>{' '}
                                    </>
                                }
                                <Button color="danger" onClick={handleItemDeletePopupClose1}>Cancel</Button>
                            </ModalFooter>
                        </Modal>
                    </div>
            }
        </div>
    )
}
export default WinterGrazing;